// extracted by mini-css-extract-plugin
module.exports = {"alert":"KontaktOssKanalAlert_alert__H3c4C"};